import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import '../styles/AboutUs.css';

export default function AboutUs() {
  return (
    <div className="about-container">
      <Navbar />

      <section className="about-header" style={{ padding: '3rem 1rem', textAlign: 'center', background: '#f5f8ff' }}>
        <h1>About Soulful Yatra</h1>
        <p style={{ maxWidth: '700px', margin: '1rem auto', fontSize: '1.1rem', color: '#555' }}>
          Soulful Yatra is a comprehensive travel platform designed to simplify and enrich your travel experiences. Our mission is to help travelers discover destinations, plan trips, find hotels and local cuisine, and explore transportation options—all in one place.
        </p>
      </section>

      <section className="about-mission" style={{ padding: '2rem 1rem', maxWidth: '900px', margin: '0 auto' }}>
        <h2>What We Do</h2>
        <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.6' }}>
          We provide intelligent travel recommendations, including:
        </p>
        <ul style={{ fontSize: '1rem', color: '#555', lineHeight: '1.6', marginLeft: '1.5rem' }}>
          <li>Curated vacation destinations tailored to your interests.</li>
          <li>Hotel suggestions with details on comfort, amenities, and proximity.</li>
          <li>Local cuisine and restaurant recommendations to enhance your culinary journey.</li>
          <li>Transportation options and travel itineraries to make planning seamless.</li>
          <li>Travel vlogs and content to inspire your next adventure.</li>
        </ul>
      </section>

      <section className="about-vision" style={{ padding: '2rem 1rem', background: '#f0f4ff', maxWidth: '900px', margin: '0 auto' }}>
        <h2>Our Vision</h2>
        <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.6' }}>
          Our vision is to empower travelers with reliable information and personalized suggestions that make every journey memorable. By combining technology with local insights, we aim to create a seamless and enjoyable experience from trip planning to exploration.
        </p>
      </section>

      <section className="about-value" style={{ padding: '2rem 1rem', maxWidth: '900px', margin: '0 auto' }}>
        <h2>Why Choose Us</h2>
        <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.6' }}>
          Soulful Yatra is committed to delivering accurate, user-focused travel recommendations. We prioritize quality, convenience, and personalization to ensure that every traveler can make informed decisions and enjoy a truly enriching experience.
        </p>
      </section>

      <Footer />
    </div>
  );
}
